"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionMode = void 0;
/**
 * Enum to define current selection mode
 */
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["NONE"] = 0] = "NONE";
    SelectionMode[SelectionMode["POINT"] = 1] = "POINT";
    SelectionMode[SelectionMode["RECT"] = 2] = "RECT";
    SelectionMode[SelectionMode["COPYRECT"] = 3] = "COPYRECT";
    SelectionMode[SelectionMode["POLYLINE"] = 4] = "POLYLINE";
    SelectionMode[SelectionMode["POLYGON"] = 5] = "POLYGON";
})(SelectionMode = exports.SelectionMode || (exports.SelectionMode = {}));
//# sourceMappingURL=ISelectorSettings.js.map